import type {
  DepositMethodDescriptor,
  DepositMethodId,
  DestinationMethodDescriptor,
  SelectableMethodDescriptor,
} from "../types";

export const isDestination = (
  method: DepositMethodDescriptor,
): method is DestinationMethodDescriptor => {
  return "destination" in method;
};

export const partitionMethods = <T extends DepositMethodDescriptor>(
  methods: readonly T[],
) => {
  return {
    selectableMethods: methods.filter(
      (method): method is Extract<T, SelectableMethodDescriptor> =>
        !isDestination(method),
    ),
    destinations: methods.filter(
      (method): method is Extract<T, DestinationMethodDescriptor> =>
        isDestination(method),
    ),
  };
};

const DEFAULT_METHOD_PREFERENCE = [
  "apple-pay",
  "google-pay",
] as const satisfies readonly DepositMethodId[];

export const pickDefaultMethod = <T extends SelectableMethodDescriptor>(
  methods: readonly T[],
): T => {
  for (const id of DEFAULT_METHOD_PREFERENCE) {
    const preferred = methods.find((method) => method.id === id);
    if (preferred) return preferred;
  }

  return methods[0];
};
